import content from "./content.json";

export const catalogText = content.catalog;

export const instructionsTextSquat = content.instructions.squat;
export const instructionsTextPushUp = content.instructions.pushup;
export const instructionsTextDeadBug = content.instructions.deadbug;
export const instructionsTextBridge = content.instructions.bridge;
export const instructionsTextPullUp = content.instructions.pullup;
export const instructionsTextMuscleUp = content.instructions.muscleup;
export const instructionsTextLateralExternalRotation = content.instructions.lateralExternalRotation;
export const instructionsTextPlank = content.instructions.plank;
export const instructionsTextPilatesHundred = content.instructions.pilatesHundred;
export const instructionsTextLunge = content.instructions.lunge;
export const instructionsTextLegRaise = content.instructions.legRaise;
export const instructionsTextToeTouch = content.instructions.toeTouch;
export const instructionsTextStandingObliqueCrunch = content.instructions.standingObliqueCrunch;
export const instructionsTextTreePose = content.instructions.treePose;
export const instructionsTextShoulderPress = content.instructions.shoulderPress;

//game
export const instructionsTextPushupGame = content.instructions.pushupGame;
export const instructionsTextSquatGame = content.instructions.squatGame;

export const instructionsVideoSquat = content.instructionVideos.squat;
export const instructionsVideoPushUp = content.instructionVideos.pushup;
export const instructionsVideoDeadBug = content.instructionVideos.deadbug;
export const instructionsVideoBridge = content.instructionVideos.bridge;
export const instructionsVideoPullUp = content.instructionVideos.pullup;
export const instructionsVideoMuscleUp = content.instructionVideos.muscleup;
export const instructionsVideoLateralExternalRotation =
  content.instructionVideos.lateralExternalRotation;
export const instructionsVideoPlank = content.instructionVideos.plank;
export const instructionsVideoPilatesHundred = content.instructionVideos.pilatesHundred;
export const instructionsVideoLunge = content.instructionVideos.lunge;
export const instructionsVideoLegRaise = content.instructionVideos.legRaise;
export const instructionsVideoToeTouch = content.instructionVideos.toeTouch;
export const instructionsVideoStandingObliqueCrunch =
  content.instructionVideos.standingObliqueCrunch;
export const instructionsVideoTreePose = content.instructionVideos.treePose;
export const instructionsVideoShoulderPress = content.instructionVideos.shoulderPress;

//game
export const instructionsVideoSquatGame = content.instructionVideos.squatGame;

export const disclaimerText = content.legal.disclaimer;


